import { PrimaryButton } from './Button';
import { CONSULT_SURVEY } from '../data/url';
declare global {
  interface Window {
    gtag_report_conversion: (url?: string) => boolean;
  }
}

interface Props  {
    width?: string | number;
};

export const ConsultButton = (props: Props) => {
    const handleContactClick = () => {
        if (window.gtag_report_conversion) {
            window.gtag_report_conversion(CONSULT_SURVEY);
        }
        setTimeout(() => {
            window.open(CONSULT_SURVEY, '_blank', 'noopener,noreferrer');
        }, 100);
    };
    return (
        <PrimaryButton onClick={handleContactClick} content='立即洽詢' width={props.width} />
    );
};